'use client';

import { Button } from '@/components/ui/button';
import { PencilIcon } from 'lucide-react';

interface TournamentDetailsBannerProps {
  bannerUrl: string | null;
  name: string;
  onEditBannerClick: () => void;
  isEditMode?: boolean;
}

export function TournamentDetailsBanner({
  bannerUrl,
  name,
  onEditBannerClick,
  isEditMode = false,
}: TournamentDetailsBannerProps) {
  return (
    <div className="relative mb-8 h-64 overflow-hidden rounded-lg bg-gradient-to-r from-blue-500 to-purple-600 md:h-80">
      {bannerUrl ? (
        <img
          src={bannerUrl || '/placeholder.svg'}
          alt={`Banner del torneo ${name}`}
          className="h-full w-full object-cover"
        />
      ) : (
        <div className="flex h-full items-center justify-center">
          <div className="text-center text-white">
            <h2 className="text-2xl font-bold md:text-4xl">{name}</h2>
            <p className="mt-2 text-lg opacity-90">Banner del Torneo</p>
          </div>
        </div>
      )}

      {isEditMode && (
        <div className="absolute right-4 top-4">
          <Button
            variant="secondary"
            size="icon"
            onClick={onEditBannerClick}
            className="h-10 w-10 bg-white/90 hover:bg-white"
            aria-label="Editar banner del torneo"
          >
            <PencilIcon className="h-5 w-5" />
          </Button>
        </div>
      )}
    </div>
  );
}
